import { render, staticRenderFns } from "./PlayoffHint.vue?vue&type=template&id=145e850c"
import script from "./PlayoffHint.vue?vue&type=script&lang=js"
export * from "./PlayoffHint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports